var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 17.7401C11.7584 17.7408 11.6279 17.7156 11.5061 17.6658C11.3843 17.6161 11.2735 17.5427 11.18 17.4501L5.18001 11.4501C5.08629 11.3571 5.01189 11.2465 4.96112 11.1246C4.91035 11.0028 4.88422 10.8721 4.88422 10.7401C4.88422 10.608 4.91035 10.4773 4.96112 10.3555C5.01189 10.2336 5.08629 10.123 5.18001 10.0301C5.36738 9.8438 5.62083 9.73926 5.88502 9.73926C6.1492 9.73926 6.40265 9.8438 6.59001 10.0301L11.89 15.3301L17.18 10.0301C17.3674 9.8438 17.6208 9.73926 17.885 9.73926C18.1492 9.73926 18.4027 9.8438 18.59 10.0301C18.6837 10.123 18.7581 10.2336 18.8089 10.3555C18.8597 10.4773 18.8858 10.608 18.8858 10.7401C18.8858 10.8721 18.8597 11.0028 18.8089 11.1246C18.7581 11.2465 18.6837 11.3571 18.59 11.4501L12.59 17.4501C12.4038 17.6348 12.1524 17.7389 11.89 17.7401Z",
    fill: "#424C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.747ff3530893a9659e3788c553c520c6.svg";
export { ForwardRef as ReactComponent };